<template>
    <el-drawer
        :title="$t('clients.walletManagementTitle')"
        :visible.sync="visible"
        direction="rtl"
        @open="open"
        :size="width"
        :before-close="handleClose">
        <div class="drawer__content scrollable only-y" :style="divHeight" >
        <div class="right">
            <el-button type="primary" :disabled="!canRemoveCards" @click="handleDelete"><i class="mdi mdi-minus-circle mr-5" />{{$t('common.Remove')}}</el-button>
            <el-button type="primary" @click="handleShowPaymentForm(true)" :disabled="showPaymentForm"><i class="mdi mdi-plus-circle mr-5" />{{$t('common.Add')}}</el-button>
        </div>
        <div class="m-10 border p-10" v-show="paymentFormInitialized">
          <h4>{{ $t('clients.addCardFormTitle') }}</h4>
            <el-form>
                <form ref="stripeForm" role="stripe" id="payment-form" method="POST" action="javascript:void(0);">
                <el-form-item label="Nom">
                    <el-input v-model="cardHolderName" type="text" />
                </el-form-item>
                
                <div class="stripe" id="stripe-form">
                    <div class="row">
                        <div class="field">
                            <div id="card-element" class="input empty"></div>
                            <label for="example2-card-number" data-tid="elements_examples.form.card_number_label">Card number</label>
                            <div class="baseline"></div>
                        </div>
                    </div>
                </div>

                <div id="card-errors" role="alert"></div>
                </form>
            </el-form>
            <p class="bg-accent-lighter p-10">
              <span>{{ $t('clients.addPaymentDisclaimer') }}</span><br/>
              <el-checkbox v-model="consent">{{ $t('common.IConfirm') }}</el-checkbox>
            </p>
            <el-button @click="handleCancelAddCard">{{$t('common.Cancel')}}</el-button>
            <el-button type="primary" @click="confirm" :disabled="!consent">{{$t('common.Add')}}</el-button>
        </div>
        <el-divider />
        <h4>{{ $t('clients.cardPresentTitle') }}</h4>
        <div class="m-10 paymentMethodsList" >
            <el-checkbox-group v-model="selectedCards" v-loading="loading">
                <el-checkbox v-for="pm in paymentMethods" :key="pm.id" border class="m-10" :label="pm.id" :disabled="showPaymentForm">
                    <paymentCardInfo  :brand="pm.card.brand" :last4="pm.card.last4"/>
                </el-checkbox>
            </el-checkbox-group>
            <p class="bg-info-lighter p-10" v-if="paymentMethodsSize === 0 && loading ==false"><i class="el-icon-warning-outline"></i> {{ $t('clients.noPaymentMethods') }}</p>
        </div>

        <div class="dialog-footer card-shadow--large">
            <el-button @click="handleClose">{{$t('common.Cancel')}}</el-button>
        </div>
        </div>
    </el-drawer>
  </template>
  <script>
  import paymentCardInfo from '@/components/payment-card-info';
  import paymentApi from '@/services/API/payment';
  import { mapState, mapActions } from 'vuex';
  import Promise from 'bluebird'
  export default {
      name: 'Wallet-Management-Dialog',
    props: {
      customerId : {
        required: true,
      },
      portausCompanyId: {
        required: true,
      },
      visible: {
        type: Boolean,
        required: true,
        default: false,
      }
    },
    data() {
        return {
            paymentMethods: [],
            selectedCards: [],
            showPaymentForm: false,
            loading: false,
            paymentFormInitialized: false,
            consent: false,
            window: {
                width: 0,
                height: 0
            },
            cardHolderName: null,
            stripePK: null,
            cardElement : null,
            elements : null,
            stripe: null,
        }
      },
    components: {
        paymentCardInfo,
    },
    computed: {
        paymentMethodsSize () {
          return _.size(this.paymentMethods);
        },
        canRemoveCards () {
            return _.size(this.selectedCards) > 0;
        },
        divHeight(){
            return "height :"+(this.window.height-130) + "px"
        },
        width(){
            return this.window.width > 1024 ? "50%" : "100%";
        },
        ...mapState('controlData', ['portausCompanies'])
    },
      methods: {
        handleDelete () {
          this.loading = true;
          return Promise.each(this.selectedCards, (card) => {
            return paymentApi.deletePaymentMethod(card);
          })
          .then(() => {
            this.selectedCards = [];
            this.fetchPaymentMethods(this.customerId);
          })
        },
        confirm () {
          this.loading = true;
          const postData = {
            amount: 0,
            customer: {
              id: this.customerId,
            },
            portausCompanyId: this.portausCompanyId,
            isSavingCard: true,
          }
          paymentApi.setupPaymentIntent(postData)
            .then((paymentIntent) => {
              
              return this.stripe.confirmCardSetup(paymentIntent.client_secret, {
                payment_method: {
                  card: this.cardElement,
                  billing_details: {
                    name: this.cardHolderName
                  }
                }
              }).then(() => {
                this.handleCancelAddCard();
                this.fetchPaymentMethods(this.customerId);
              })
              
            })

        },
        handleCancelAddCard () {
          this.cardHolderName = null;
          this.consent = false;
          this.paymentFormInitialized = false;
          this.showPaymentForm = false;
          if (this.cardElement != null) {
            this.cardElement.unmount();
          }
        },
        initStripeKey (){
            const mySTripeKey = _.get(_.find(this.portausCompanies, pc => pc.id === this.portausCompanyId), 'stripePublicKey');
            this.stripePK = mySTripeKey;
        },
        handleShowPaymentForm (show) {
            this.initSelectedCards();
            if (show) {
              this.$nextTick(() => {
                this.initializePaymentForm();
                this.showPaymentForm = true;
              })
                
            } else {
                this.showPaymentForm = false;
            }
        },
        initSelectedCards () {
            this.selectedCards = [];
        },
        fetchPaymentMethods (customerId) {
            this.loading = true;
            return paymentApi.getCustomerPaymentMethods(customerId)
                .then((paymentMethods) => {
                    this.paymentMethods = paymentMethods;
                    this.loading = false;
                }).catch((err) => {
                    this.loading = false;
                    this.$message.error('Une erreur est survenue. Veuillez réessayer plus tard!');
                })
        },
        handleClose () {
            this.$emit('close');
            this.initSelectedCards();
            this.handleCancelAddCard();
        },
        open(){
          paymentApi.createStripeCustomer(this.customerId);
            this.initStripeKey();
            this.fetchPaymentMethods(this.customerId);
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        initializePaymentForm(){
            this.paymentFormInitialized=true;
            this.stripe = Stripe(this.stripePK);
            this.elements = this.stripe.elements();
            this.cardElement = null;
            // if (this.paymentMethod === -1) {
                var elementStyles = {
                base: {
                    color: '#32325D',
                    fontWeight: 500,
                    // fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
                    fontSize: '16px',
                    fontSmoothing: 'antialiased',

                    '::placeholder': {
                    color: '#CFD7DF',
                    },
                    ':-webkit-autofill': {
                    color: '#e39f48',
                    },
                },
                invalid: {
                    color: '#E25950',

                    '::placeholder': {
                    color: '#FFCCA5',
                    },
                },
                };

            var elementClasses = {
                focus: 'focused',
                empty: 'empty',
                invalid: 'invalid',
            };

            var style = {
                base: {
                color: "#32325d",
                }
            };
            let _this = this;
            if(this.cardElement==null){
                this.cardElement = this.elements.create('card', {
                    style: elementStyles,
                    classes: elementClasses,
                });
                this.cardElement.mount('#card-element');
                this.cardElement.on('change', function(event) {
                    _this.complete = event.complete;
                    if (event.complete) {
                    _this.cardBrandName = event.brand;
                    } else if (event.error) {
                    _this.complete = false;
                    // console.log(event.error);
                    }
                });
                
            // }
            this.paymentFormInitialized = true;
        }
      
    },
        ...mapActions('controlData', ['fetchPortausCompany'])
    },
    mounted () {
        
    },
    created(){
        this.fetchPortausCompany();
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
  }
  </script>
<style lang="scss" scoped>

#cardNumber {
  margin-top:10px;
	height:40px;

	padding-left:5px;
	padding-right:5px;
  color:#5B6266;
  -webkit-appearance: none;
    background-color: #FFFFFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
}

.credit-card-box .panel-title {
    display: inline;
    font-weight: bold;
}
.credit-card-box .form-control.error {
    border-color: red !important;
    outline: 0;
    // box-shadow: inset 0 1px 1px rgba(0,0,0,0.075),0 0 8px rgba(255,0,0,0.6);
}
.credit-card-box label.error {
  font-weight: bold;
  color: red;
  padding: 2px 8px;
  margin-top: 2px;
}
.credit-card-box .payment-errors {
  font-weight: bold;
  color: red;
  padding: 2px 8px;
  margin-top: 12px;
}
.credit-card-box label {
    display: block;
}

.credit-card-box .display-tr {
    display: table-row;
}
.credit-card-box .display-td {
    display: table-cell;
    vertical-align: middle;
    width: 50%;
}

.credit-card-box .panel-heading img {
    min-width: 180px;
    border-style: solid;
    border-width: 3px;
    border-color: white;
    box-shadow: 3px 3px 5px #D3D3D3;
}

stripe {
  background-color: #fff;
}

.stripe * {
  // font-family: Source Code Pro, Consolas, Menlo, monospace;
  font-size: 16px;
  font-weight: 500;
}

.stripe .row {
  display: -ms-flexbox;
  display: flex;
  margin: 0 5px 10px;
}

.stripe .field {
  position: relative;
  width: 100%;
  height: 50px;
  margin: 0 10px;
}

.stripe .field.half-width {
  width: 50%;
}

.stripe .field.quarter-width {
  width: calc(25% - 10px);
}

.stripe .baseline {
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  bottom: 0;
  background-color: #cfd7df;
  transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe label {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 8px;
  color: #cfd7df;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform-origin: 0 50%;
  cursor: text;
  pointer-events: none;
  transition-property: color, transform;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe .input {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding-bottom: 7px;
  color: #32325d;
  background-color: transparent;
}

.stripe .input::-webkit-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe .input::-moz-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe .input:-ms-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe .input.StripeElement {
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  will-change: opacity;
}

.stripe .input.focused,
.stripe .input:not(.empty) {
  opacity: 1;
}

.stripe .input.focused::-webkit-input-placeholder,
.stripe .input:not(.empty)::-webkit-input-placeholder {
  color: #cfd7df;
}

.stripe .input.focused::-moz-placeholder,
.stripe .input:not(.empty)::-moz-placeholder {
  color: #cfd7df;
}

.stripe .input.focused:-ms-input-placeholder,
.stripe .input:not(.empty):-ms-input-placeholder {
  color: #cfd7df;
}

.stripe .input.focused + label,
.stripe .input:not(.empty) + label {
  color: #aab7c4;
  transform: scale(0.85) translateY(-25px);
  cursor: default;
}

.stripe .input.focused + label {
  color: #5f8fdf;
}

.stripe .input.invalid + label {
  color: #ffa27b;
}

.stripe .input.focused + label + .baseline {
  background-color: #5f8fdf;
}

.stripe .input.focused.invalid + label + .baseline {
  background-color: #e25950;
}

.stripe input, .stripe button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  border-style: none;
}

.stripe input:-webkit-autofill {
  -webkit-text-fill-color: #e39f48;
  transition: background-color 100000000s;
  -webkit-animation: 1ms void-animation-out;
}

.stripe .StripeElement--webkit-autofill {
  background: transparent !important;
}

.stripe input, .stripe button {
  -webkit-animation: 1ms void-animation-out;
}

.stripe button {
  display: block;
  width: calc(100% - 30px);
  height: 40px;
  margin: 40px 15px 0;
  background-color: #24b47e;
  border-radius: 4px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  cursor: pointer;
}

.stripe .error svg {
  margin-top: 0 !important;
}

.stripe .error svg .base {
  fill: #e25950;
}

.stripe .error svg .glyph {
  fill: #fff;
}

.stripe .error .message {
  color: #e25950;
}

.stripe .success .icon .border {
  stroke: #abe9d2;
}

.stripe .success .icon .checkmark {
  stroke: #24b47e;
}

.stripe .success .title {
  color: #32325d;
  font-size: 16px !important;
}

.stripe .success .message {
  color: #8898aa;
  font-size: 13px !important;
}

.stripe .success .reset path {
  fill: #24b47e;
}

#cardCVC {
	margin-top:10px;
	height:40px;
	width:70px;
	border: 1px solid rgba(95, 143, 223, 0.2);
	padding-left:5px;
	padding-right:5px;
  color:#5B6266;
  -webkit-appearance: none;
    background-color: #FFFFFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#cardExpiry {
	margin-top:10px;
	height:40px;
	width:100px;
	border: 1px solid rgba(95, 143, 223, 0.2);
	padding-left:5px;
	padding-right:5px;
  color:#5B6266;
  -webkit-appearance: none;
    background-color: #FFFFFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.el-checkbox.is-bordered {
    height:60px;
    width:100%;
  }

.el-checkbox-group {
    padding-right: 40px;
}
.right {
    text-align:right;
}

.paymentMethodsList {
    width:100%;
}
.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
  